/**
 * 获取长连接地址
 */

import { isSandbox } from '@umu/umu-ua';
import { isSystem } from '@umu/ukit-lang';
export function getSocketUrl() {
    let socketUrl = '';
    socketUrl = 'wss://uim.umu.cn:8095/sub';





    // socketUrl = `ws://52.80.31.35:8090/sub`;
    socketUrl = `wss://uim.umucdn.cn:8090/sub`;
    if (isSandbox) {
        socketUrl = `wss://uim.umucdn.cn:8090/sub`;
    }
    return socketUrl;
}
/**
 * 获取联系客服电话
 * 目前仅支持CN和JP其他站点后续补充
 */
const CONTACT_PHONE = (() => {
    if (isSystem('CN')) {
        return '400-007-2121';
    }
    if (isSystem('JP')) {
        return '03-4400-7419';
    }
    return '';
})();

export const getContactPhone = (): string => CONTACT_PHONE;
